import { splitParagraphs } from '../utils/storyText.js';

/**
 * Renders story body with paragraph breaks preserved.
 */
export default function StoryExcerpt({ text, className = '', paragraphClassName = '' }) {
  const paragraphs = splitParagraphs(text);
  if (!paragraphs.length) return null;

  if (paragraphs.length === 1) {
    return <p className={`${className} ${paragraphClassName}`.trim()}>{paragraphs[0]}</p>;
  }

  return (
    <div className={className}>
      {paragraphs.map((p, i) => (
        <p key={i} className={paragraphClassName || undefined}>
          {p}
        </p>
      ))}
    </div>
  );
}
